// Auth gate for routes. While the initial auth check resolves we show a neutral
// loading state; an unauthenticated user is redirected to /login.

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Authenticating…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
